import { render } from "./FormParameterInput.vue?vue&type=template&id=2a537620&scoped=true&ts=true"
import script from "./FormParameterInput.vue?vue&type=script&lang=ts"
export * from "./FormParameterInput.vue?vue&type=script&lang=ts"

import "./FormParameterInput.vue?vue&type=style&index=0&id=2a537620&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a537620"]])

export default __exports__